module.exports = __webpack_public_path__ + "static/media/openfactor.4b91cd54.jpeg";